import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "./layout.scss";

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Mobile Sidebar Toggle Button */}
      <div className="mobileToggle" onClick={() => setMobileOpen(!mobileOpen)}>
        <span className={`hamburger ${mobileOpen ? 'hOpen1' : ''}`}></span>
        <span className={`hamburger ${mobileOpen ? 'hOpen2' : ''}`}></span>
        <span className={`hamburger ${mobileOpen ? 'hOpen3' : ''}`}></span>
      </div>

      <Sidebar 
        mobileOpen={mobileOpen} 
        setMobileOpen={setMobileOpen} 
        collapsed={collapsed} 
        setCollapsed={setCollapsed} 
      />
      
      <div className={`admin-layout__main ${collapsed ? 'collapsed' : ''}`}>
        <Header />
        <main className="admin-layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
